import styles from "./ui.module.css";

// Estados reales (guía 10): el verde queda reservado para "disponible / verificado".
export type StatusKind = "available" | "pilot" | "progress" | "roadmap";

export function Status({ kind, children }: { kind: StatusKind; children: React.ReactNode }) {
  return (
    <span className={styles.status} data-kind={kind}>
      {children}
    </span>
  );
}
